import { SearchBaseModel } from '../commonModels';

export class ServiceCompaniesSearchModel extends SearchBaseModel {
    public name: string;
    public isActive: boolean;
    public nip: string;
    public address: string;
    public serviceCompanyTypeId: number;
    public serviceCompanyId: number;
    public ownerName: string;
    constructor() {
        super();
        this.name = null;
        this.serviceCompanyId = null;
        this.isActive = null;
        this.nip = null;
        this.address = null;
        this.serviceCompanyTypeId = null;
        this.ownerName = null;
    }
    /*
    • Firma serwisowa (combo)
    • Nazwa firmy serwisowej (tekst)
    • Aktywny (tak / nie)
    • NIP
    • Adres (tekst)
    • Typ Firmy Serwisowej (partnerski / własny)
    • Nazwa właściciela (tekst)
    */
}
